import React, { createContext, useContext, useEffect, useState } from "react";

const LANGS = ["tr", "ar", "en", "ru"];
const RTL = { ar: true };

const dict = {
  brand: {
    tr: "Ariaf Catering",
    ar: "أرياف كيترنغ",
    en: "Ariaf Catering",
    ru: "Ариаф Кейтеринг",
  },
  tagline: {
    tr: "Umre Yolcularına Vatan Sofrası",
    ar: "مائدة الوطن لضيوف العمرة",
    en: "A Taste of Home for Umrah Pilgrims",
    ru: "Домашний стол для гостей умры",
  },
  nav: {
    home: { tr: "Anasayfa", ar: "الرئيسية", en: "Home", ru: "Главная" },
    gallery: { tr: "Galeri", ar: "المعرض", en: "Gallery", ru: "Галерея" },
    menu: { tr: "Menü", ar: "القائمة", en: "Menu", ru: "Меню" },
    hotels: { tr: "Oteller", ar: "الفنادق", en: "Hotels", ru: "Отели" },
    blog: { tr: "Blog", ar: "المدونة", en: "Blog", ru: "Блог" },
    faq: { tr: "SSS", ar: "الأسئلة", en: "FAQ", ru: "Вопросы" },
    recipes: { tr: "Tarifler", ar: "الوصفات", en: "Recipes", ru: "Рецепты" },
    contact: { tr: "İletişim", ar: "تواصل", en: "Contact", ru: "Контакты" },
    admin: { tr: "Yönetici", ar: "الإدارة", en: "Admin", ru: "Админ" },
  },
  hero: {
    kicker: {
      tr: "Ariaf Catering — Mekke",
      ar: "أرياف كيترنغ — مكة المكرمة",
      en: "Ariaf Catering — Makkah",
      ru: "Ариаф Кейтеринг — Мекка",
    },
    title: {
      tr: "Yılların tecrübesi, kutsal bir yolculuğun tadı.",
      ar: "خبرة السنين، مذاق رحلة مقدّسة.",
      en: "Years of craft, the taste of a sacred journey.",
      ru: "Годы мастерства, вкус священного пути.",
    },
    subtitle: {
      tr: "Türk, Arap ve Özbek mutfağının en seçkin lezzetleriyle, hizmet verdiğimiz Mekke otellerinde günlük 3 öğün.",
      ar: "أشهى أطباق المطبخ التركي والعربي والأوزبكي، 3 وجبات يومياً في فنادق مكة التي نخدمها.",
      en: "The finest Turkish, Arabic and Uzbek cuisine served three times a day at the Makkah hotels we partner with.",
      ru: "Изысканные блюда турецкой, арабской и узбекской кухни трижды в день в отелях Мекки, с которыми мы работаем.",
    },
    cta_hotels: {
      tr: "Otelleri Gör",
      ar: "شاهد الفنادق",
      en: "View Hotels",
      ru: "Смотреть отели",
    },
    cta_menu: {
      tr: "Haftalık Menü",
      ar: "قائمة الأسبوع",
      en: "This Week's Menu",
      ru: "Меню недели",
    },
  },
  sections: {
    gallery_title: { tr: "Sofralarımızdan Kareler", ar: "لقطات من موائدنا", en: "Moments from Our Tables", ru: "Кадры с наших столов" },
    gallery_desc: {
      tr: "Fotoğraf ve videolarla Ariaf lezzetleri.",
      ar: "صور وفيديوهات لنكهات أرياف.",
      en: "Photos and videos of the Ariaf flavors.",
      ru: "Фотографии и видео вкусов Ariaf.",
    },
    hotels_title: { tr: "Hizmet Verdiğimiz Oteller", ar: "الفنادق التي نخدمها", en: "Hotels We Serve", ru: "Отели, которые мы обслуживаем" },
    hotels_desc: {
      tr: "Mekke'nin seçkin otellerinde ağırlanan misafirlerimize günlük menülerimizi sunuyoruz.",
      ar: "نقدم قوائمنا اليومية لضيوفنا في نخبة فنادق مكة المكرمة.",
      en: "We serve daily menus to guests staying at select hotels in Makkah.",
      ru: "Мы подаём наши ежедневные меню гостям в избранных отелях Мекки.",
    },
    menu_title: { tr: "Haftalık Menü", ar: "قائمة الأسبوع", en: "Weekly Menu", ru: "Меню на неделю" },
    menu_desc: {
      tr: "Umre yolcularımızın günlük yemeklerine kolayca ulaşabilmesi için açık menü. Her güne tıklayıp videolarımızı izleyebilirsiniz.",
      ar: "قائمة مفتوحة ليطّلع ضيوف العمرة على وجباتهم اليومية. اضغط على أي يوم لمشاهدة الفيديو.",
      en: "An open weekly schedule for our Umrah guests. Tap any day to watch the video.",
      ru: "Открытое недельное расписание для наших гостей умры. Нажмите на любой день, чтобы посмотреть видео.",
    },
    why_title: {
      tr: "Neden Ariaf?",
      ar: "لماذا أرياف؟",
      en: "Why Ariaf?",
      ru: "Почему Ариаф?",
    },
    why_desc: {
      tr: "Yılların ustalığı, sıcak bir sofra ve kutsal yolculuğunuza duyulan saygıyla hazırlanan her tabak.",
      ar: "خبرة السنين، مائدة دافئة، وكل طبق يُعدّ باحترام لرحلتكم المقدّسة.",
      en: "Years of craft, a warm table, and every plate prepared with respect for your sacred journey.",
      ru: "Годы мастерства, тёплый стол и каждое блюдо, приготовленное с уважением к вашему священному пути.",
    },
    breakfast: { tr: "Kahvaltı", ar: "الفطور", en: "Breakfast", ru: "Завтрак" },
    lunch: { tr: "Öğle", ar: "الغداء", en: "Lunch", ru: "Обед" },
    dinner: { tr: "Akşam", ar: "العشاء", en: "Dinner", ru: "Ужин" },
    day: { tr: "Gün", ar: "اليوم", en: "Day", ru: "День" },
    from: { tr: "başlangıç", ar: "ابتداءً من", en: "from", ru: "от" },
    testimonials_title: {
      tr: "Misafirlerimizin Sesinden",
      ar: "بأصوات ضيوفنا",
      en: "From Our Guests",
      ru: "Слова наших гостей",
    },
    chefs_title: {
      tr: "Mutfağımızdan",
      ar: "من مطبخنا",
      en: "From Our Kitchen",
      ru: "Из нашей кухни",
    },
    chefs_desc: {
      tr: "Sofranızın arkasındaki ustalar.",
      ar: "الأساتذة خلف مائدتكم.",
      en: "The masters behind your table.",
      ru: "Мастера, стоящие за вашим столом.",
    },
    certificates_title: {
      tr: "Sertifikalarımız",
      ar: "شهاداتنا",
      en: "Our Certifications",
      ru: "Наши сертификаты",
    },
    blog_title: {
      tr: "Ariaf Günlüğü",
      ar: "يوميات أرياف",
      en: "The Ariaf Journal",
      ru: "Дневник Ariaf",
    },
    blog_desc: {
      tr: "Mutfağımızdan tarifler, Umre rehberleri ve sofra hikayeleri.",
      ar: "وصفات من مطبخنا، أدلة العمرة، وقصص من المائدة.",
      en: "Recipes from our kitchen, Umrah guides, and table stories.",
      ru: "Рецепты с нашей кухни, гиды по умре и истории застолья.",
    },
    faq_title: {
      tr: "Sık Sorulan Sorular",
      ar: "الأسئلة الشائعة",
      en: "Frequently Asked Questions",
      ru: "Часто задаваемые вопросы",
    },
    faq_desc: {
      tr: "Umre yolcularımızın en çok merak ettiği konular.",
      ar: "أهم ما يتساءل عنه ضيوف العمرة.",
      en: "The most common questions from our Umrah guests.",
      ru: "Самые частые вопросы наших гостей умры.",
    },
    location_title: {
      tr: "Konum",
      ar: "الموقع",
      en: "Location",
      ru: "Расположение",
    },
  },
  cta: {
    inquire: { tr: "Bilgi Al / Rezervasyon", ar: "استفسر / احجز", en: "Inquire / Book", ru: "Запрос / Бронь" },
    send: { tr: "Gönder", ar: "إرسال", en: "Send", ru: "Отправить" },
    view_hotel: { tr: "Oteli Gör", ar: "شاهد الفندق", en: "View Hotel", ru: "Смотреть отель" },
    login: { tr: "Giriş", ar: "دخول", en: "Login", ru: "Войти" },
    logout: { tr: "Çıkış", ar: "خروج", en: "Logout", ru: "Выйти" },
    all: { tr: "Tümü", ar: "الكل", en: "All", ru: "Все" },
    watch_video: { tr: "Videoyu izle", ar: "شاهد الفيديو", en: "Watch video", ru: "Смотреть видео" },
    view_details: { tr: "Detaylar", ar: "التفاصيل", en: "View details", ru: "Подробнее" },
    no_media: { tr: "Henüz medya eklenmemiş", ar: "لم تُضف وسائط بعد", en: "No media yet", ru: "Медиа пока нет" },
  },
  wa: {
    have_question: { tr: "Sorunuz mu var?", ar: "هل لديك سؤال؟", en: "Have a question?", ru: "Есть вопрос?" },
    contact_us: { tr: "Bizimle iletişime geçin", ar: "تواصل معنا", en: "Contact us", ru: "Свяжитесь с нами" },
  },
  form: {
    name: { tr: "Ad Soyad", ar: "الاسم الكامل", en: "Full name", ru: "Ф.И.О." },
    phone: { tr: "Telefon", ar: "الهاتف", en: "Phone", ru: "Телефон" },
    whatsapp: { tr: "WhatsApp", ar: "واتساب", en: "WhatsApp", ru: "WhatsApp" },
    email: { tr: "E-posta", ar: "البريد الإلكتروني", en: "Email", ru: "Эл. почта" },
    arrival: { tr: "Varış tarihi", ar: "تاريخ الوصول", en: "Arrival date", ru: "Дата приезда" },
    departure: { tr: "Ayrılış tarihi", ar: "تاريخ المغادرة", en: "Departure date", ru: "Дата отъезда" },
    guests: { tr: "Misafir sayısı", ar: "عدد الضيوف", en: "Number of guests", ru: "Количество гостей" },
    notes: { tr: "Notlar", ar: "ملاحظات", en: "Notes", ru: "Примечания" },
    birthday: { tr: "Umre sırasında doğum gününüz mü?", ar: "هل عيد ميلادك خلال العمرة؟", en: "Birthday during your stay?", ru: "День рождения во время визита?" },
    birthday_hint: { tr: "İsteğe bağlı — belirtirseniz size özel bir tatlı hazırlarız.", ar: "اختياري — إذا ذكرت، سنُحضّر لك حلوى خاصة.", en: "Optional — if you tell us, we'll prepare a special sweet for you.", ru: "Необязательно — если укажете, мы приготовим особый десерт." },
    thanks: { tr: "Talebiniz alındı. En kısa sürede size ulaşacağız.", ar: "تم استلام طلبك. سنتواصل معك قريباً.", en: "Thank you, we'll get back to you shortly.", ru: "Спасибо, мы свяжемся с вами в ближайшее время." },
  },
  recipes: {
    get_pdf: { tr: "Ücretsiz PDF Al", ar: "احصل على PDF مجاناً", en: "Get the free PDF", ru: "Получить PDF бесплатно" },
    download: { tr: "PDF'i Gönder", ar: "أرسل PDF", en: "Send me the PDF", ru: "Отправить PDF" },
    thanks: { tr: "Teşekkürler! PDF yolda.", ar: "شكراً! الـ PDF في الطريق.", en: "Thank you! The PDF is on its way.", ru: "Спасибо! PDF в пути." },
  },
  footer: {
    rights: { tr: "Tüm hakları saklıdır.", ar: "جميع الحقوق محفوظة.", en: "All rights reserved.", ru: "Все права защищены." },
    made_with: { tr: "Altın kaliteyle hazırlandı", ar: "أُعدّ بجودة ذهبية", en: "Crafted with golden quality", ru: "Создано с золотым качеством" },
  },
  stats: {
    plates: { tr: "Günlük tabak", ar: "طبق يومي", en: "Daily plates", ru: "Блюд в день" },
    hotels: { tr: "Partner otel", ar: "فندق شريك", en: "Partner hotels", ru: "Отелей-партнёров" },
    years: { tr: "Yıllık deneyim", ar: "سنة خبرة", en: "Years of craft", ru: "Лет мастерства" },
  },
};

const LangContext = createContext({ lang: "tr", setLang: () => {}, t: () => "", tt: () => "" });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ariaf_lang") || "tr");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL[lang] ? "rtl" : "ltr";
    localStorage.setItem("ariaf_lang", lang);
  }, [lang]);

  const setLang = (l) => {
    if (LANGS.includes(l)) setLangState(l);
  };

  const t = (path) => {
    const parts = path.split(".");
    let cur = dict;
    for (const p of parts) {
      if (cur && typeof cur === "object") cur = cur[p];
      else return path;
    }
    if (cur && typeof cur === "object" && cur[lang]) return cur[lang];
    return typeof cur === "string" ? cur : path;
  };

  const tt = (obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] || obj.en || obj.tr || obj.ar || obj.ru || "";
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t, tt, isRTL: !!RTL[lang], languages: LANGS }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
